import api from '@/client/core/api'

export type PutCampaignPublicFlagsParams = {
  campaignId: number
  isPublicAnalyticsPage: number
  isPublicAnalyticsApi: number
}

type PutCampaignPublicFlagsBody = {
  isPublicAnalyticsPage: number
  isPublicAnalyticsApi: number
}

export type PutCampaignPublicFlagsApiResponse = {
  data?: boolean
  error?: {
    type?: string
    message?: string
    status?: number
  }
}

export class PutCampaignPublicFlagsApiError extends Error {
  constructor(
    public type: string,
    message?: string,
    public status?: number
  ) {
    super(message || type)
  }
}

export async function putCampaignPublicFlags(params: PutCampaignPublicFlagsParams): Promise<boolean> {
  const response = await api.put<PutCampaignPublicFlagsApiResponse, PutCampaignPublicFlagsBody>(
    `/campaigns/${params.campaignId}/publics`,
    {
      isPublicAnalyticsPage: params.isPublicAnalyticsPage,
      isPublicAnalyticsApi: params.isPublicAnalyticsApi
    }
  )

  if (response?.error?.type) {
    throw new PutCampaignPublicFlagsApiError(response.error.type, response.error.message, response.error.status)
  }

  return Boolean(response.data)
}
